<template>
    <!-- 
        Список кандидатів
        - дозволяє переглянути список кандидатів
        - створити картку кандидата
        - та інше :)
    -->

    <!-- Компонент хедеру розділу -->
    <PageHeader :title="title" />

    <b-card>
        <b-row>
            <div class="col" style="display:flex;">
                <!-- Пошук -->
                <searchBox @searchB="searchB"/>
            </div>
            <div class="col-auto">
                <div class="hstack gap-2">
                    
                    <div class="list-grid-nav hstack gap-1" >
                        
                        <button 
                            type="button" 
                            id="grid-view-button" 
                            :class="`btn btn-soft-info nav-link btn-icon fs-14 ${statusGrid ? 'active' : ''} filter-button`"
                            @click="statusGrid = true"
                        >
                            <i class="ri-grid-fill"></i>
                        </button>
                        
                        <button 
                            type="button" 
                            id="list-view-button" 
                            :class="`btn btn-soft-info nav-link btn-icon fs-14 ${!statusGrid ? 'active' : ''} filter-button`"
                            @click="statusGrid = false"
                        >
                            <i class="ri-list-unordered"></i>
                        </button>

                    </div>


                    <div>
                        <button
                            @click="showCreatedBox = true"
                            class="btn btn-success"
                        >
                            <i class="ri-add-line align-bottom me-1"></i> 
                            {{ $t('AddCandidate') }}
                        </button>
                    </div>
                </div>
            </div>
        </b-row>
    </b-card>

    <!-- <div class="row g-4 mb-3" >
                            <div class="col-sm-auto" >
                                <div >
                                    <a href="#!" class="btn btn-success"><i class="ri-add-line align-bottom me-1"></i> Add Candidate</a>
                                </div>
                            </div>
                            <div class="col-sm" >
                                <div class="d-md-flex justify-content-sm-end gap-2" >
                                    <div class="search-box ms-md-2 flex-shrink-0 mb-3 mb-md-0" >
                                        <input type="text" class="form-control" id="searchJob" placeholder="Search for candidate name or designation..." autocomplete="off">
                                        <i class="ri-search-line search-icon"></i>
                                    </div>

                                    <div class="choices" data-type="select-one" tabindex="0" role="listbox" aria-haspopup="true" aria-expanded="false" ><div class="choices__inner" ><select class="form-control w-md choices__input" data-choices="" data-choices-search-false="" hidden="" tabindex="-1" data-choice="active"><option value="Yesterday" data-custom-properties="[object Object]">Yesterday</option></select><div class="choices__list choices__list--single" ><div class="choices__item choices__item--selectable" data-item="" data-id="1" data-value="Yesterday" data-custom-properties="[object Object]" aria-selected="true" >Yesterday</div></div></div><div class="choices__list choices__list--dropdown" aria-expanded="false" ><div class="choices__list" role="listbox" ><div id="choices--enzs-item-choice-1" class="choices__item choices__item--choice choices__item--selectable is-highlighted" role="option" data-choice="" data-id="1" data-value="All" data-select-text="Press to select" data-choice-selectable="" aria-selected="true" >All</div><div id="choices--enzs-item-choice-2" class="choices__item choices__item--choice choices__item--selectable" role="option" data-choice="" data-id="2" data-value="Last 7 Days" data-select-text="Press to select" data-choice-selectable="" >Last 7 Days</div><div id="choices--enzs-item-choice-3" class="choices__item choices__item--choice choices__item--selectable" role="option" data-choice="" data-id="3" data-value="Last 30 Days" data-select-text="Press to select" data-choice-selectable="" >Last 30 Days</div><div id="choices--enzs-item-choice-4" class="choices__item choices__item--choice choices__item--selectable" role="option" data-choice="" data-id="4" data-value="Last Year" data-select-text="Press to select" data-choice-selectable="" >Last Year</div><div id="choices--enzs-item-choice-5" class="choices__item choices__item--choice choices__item--selectable" role="option" data-choice="" data-id="5" data-value="This Month" data-select-text="Press to select" data-choice-selectable="" >This Month</div><div id="choices--enzs-item-choice-6" class="choices__item choices__item--choice choices__item--selectable" role="option" data-choice="" data-id="6" data-value="Today" data-select-text="Press to select" data-choice-selectable="" >Today</div><div id="choices--enzs-item-choice-7" class="choices__item choices__item--choice is-selected choices__item--selectable" role="option" data-choice="" data-id="7" data-value="Yesterday" data-select-text="Press to select" data-choice-selectable="" >Yesterday</div></div></div></div>
                                </div>
                            </div>
                        </div> -->


    <b-row v-if="statusGrid == true">

        <template v-for="item in candidates" :key="item">

            <b-col lg="4">
                <div class="card card-animate copy" @click="open(item)" >
                    <div class="card-body" >
                        <div class="d-flex align-items-center" >
                            <div class="flex-shrink-0" >
                                <!-- <div class="avatar-lg rounded" >
                                    <img src="assets/images/users/avatar-10.jpg" alt="" class="member-img img-fluid d-block rounded" />
                                </div> -->
                                <div class="avatar-lg rounded" >
                                    <div class="avatar-title border bg-light text-primary rounded text-uppercase fs-24" >{{ this.getInitials(item.firstName + " " + item.lastName ) }}</div>
                                </div>
                            </div>
                            <div class="flex-grow-1 ms-3" >
                                <a> 
                                    <h5 class="fs-16 mb-1 fw-semibold">{{ item.typeCandidate == 'outsourcing' ? item.companyTitle + " (" + item.firstName + " " + item.lastName + " )" : item.firstName + " " + item.lastName }}</h5> 
                                </a>
                                <p class="text-muted mb-2">{{ item.position }}</p>
                                <div class="d-flex flex-wrap gap-2 align-items-center" >
                                    <div class="text-muted">{{ $t('WorkExperience') }}: <span class="">{{ item.work_experience }}</span></div>
                                </div>
                                <div class="d-flex gap-4 mt-2 text-muted" >
                                    <div ><i class="ri-map-pin-2-line text-primary me-1 align-bottom"></i>{{ item.city }}<span v-if="item.district != ''">, {{ item.district }}</span></div>
                                </div>
                                <div class="d-flex gap-2 mt-2 text-muted" >
                                    <div ><i class="ri-time-line text-primary me-1 align-bottom"></i><span class="badge bg-danger-subtle text-danger">{{ item.type_of_employment }}</span></div>
                                    <div ><span class="badge bg-info-subtle text-info">{{ item.work_schedule }}</span></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </b-col>

        </template>

    </b-row>

    <b-row v-if="statusGrid == false" class="gy-2 mb-2">

        <template v-for="item in candidates" :key="item">

            <div class="col-md-6 col-lg-12" >
                <div class="card mb-0 card-animate" @click="open(item)">
                    <div class="card-body" >
                        <div class="d-lg-flex align-items-center" >
                            <div class="flex-shrink-0" >
                                <!-- <div class="avatar-sm rounded" ><img src="assets/images/users/avatar-10.jpg" alt="" class="member-img img-fluid d-block rounded" /></div> -->
                                <div class="avatar-sm rounded" >
                                    <div class="avatar-title border bg-light text-primary rounded text-uppercase fs-16" >{{ this.getInitials(item.firstName + " " + item.lastName) }}</div>
                                </div>
                            </div>
                            <div class="ms-lg-3 my-3 my-lg-0" >
                                <a href="pages-profile.html"><h5 class="fs-14 fw-semibold mb-2">{{ item.firstName + " " + item.lastName  }} </h5></a>
                                <p class="text-muted mb-0">{{ item.position }}</p>
                            </div>
                            <div class="d-flex gap-4 mt-0 text-muted mx-auto" >
                                <div ><i class="ri-map-pin-2-line text-primary me-1 align-bottom"></i> {{ item.location }}</div>
                                <div ><i class="ri-time-line text-primary me-1 align-bottom"></i> <span class="badge bg-danger-subtle text-danger">{{ item.type_employment }}</span></div>
                                <div ><span class="badge bg-info-subtle text-info">{{ item.work_schedule }}</span></div>
                            </div>
                            <div class="d-flex flex-wrap gap-2 align-items-center mx-auto my-3 my-lg-0" >
                                <div >{{ $t('WorkExperience') }}: <span class="">{{ item.work_experience }}</span></div>
                            </div>
                            <div >
                                <a href="#!" class="btn btn-soft-success">Відкрити</a>
                                <a href="#!" class="btn btn-ghost-danger btn-icon custom-toggle active" >
                                    <span class="icon-on"><i class="ri-bookmark-line align-bottom"></i></span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </template>

    </b-row>

    <!-- Модальне вікно створення кандидата -->
    <createBox 
        v-if="showCreatedBox"
        @close="showCreatedBox = false"
    />

    <!-- Модальне вікно відкриття картки кандидата -->
    <viewBox 
        v-if="showCard.show"
        @close="showCard.show = false"
        :objCard="showCard.data"
    />

</template>

<script>
import PageHeader from "@/components/page-header"; // хедер розділу
import searchBox from '@/components/globaltable/searchbox.vue'; // компонент пошуку
import createBox from './createBox.vue'; // вікно додавання кандидата
import viewBox from './view/index'; // вікно додавання кандидата

export default {
    components: {
        PageHeader,
        searchBox,
        createBox,
        viewBox
    },
    data() {
        return{
            title: this.$t('Кандидати'), // Заголовок
            form:'',
            statusGrid: true, // тип відображення списку
            showCreatedBox: false, // статус відображення вікна створення кандидата
            showCard: {
                data: {},
                show: false
            }, // статус та дані відображення вікна картки кандидата
            candidates: [
                {
                    typeCandidate: 'full_time_employee', // тип
                    img: '', // аватар
                    status: 'new_request', // Статус
                    companyTitle: '', // назва компанії
                    firstName: 'Олег', // ім'я кандидата
                    lastName: 'Олегович', // Прізвище кандидата
                    numPhone: '380630000011', // Номер телефону кандидата
                    website: 'https://skyservice.pro', // веб-сайт
                    email: 'o@sk.pro', // Пошта кандидата
                    bday: '05.03.1992', // Дата народження
                    city: 'Київ', // Місто
                    district: 'Шевченківський', // Район
                    street: '-', // Вулиця
                    position: 'Розробник', // Посада
                    work_experience: 'Більше 5 років', // Досвід роботи
                    type_of_employment: 'Повна зайнятість', // Тип зайнятості (фріланс, фулл тайм, часткова і тд)
                    work_schedule: '10:00-15:00', // Графік роботи
                    salary: '10000', // Заробітна плата
                    skills: [
                        { label: this.$t('JavaScript'), value: 'javascript' },
                        { label: this.$t('PHP'), value: 'php' },
                    ], // Навички
                    social_networks: {
                        instagram: '',
                        facebook: '',
                        telegram: 'https://t.me/olegkrkr',
                        github: 'https://git.skyservice.pro/dashboard/projects'
                    }, // соціальні мережі
                    timeLine: [
                        {
                            nameWorker: 'Max',
                            date: '10.09.2024',
                            time: '14:33',
                            comment: 'Коментар',
                            status: 'new_request'
                        },
                        {
                            nameWorker: 'Юрій',
                            date: '15.09.2024',
                            time: '12:01',
                            comment: 'Коментар',
                            status: 'will_interview'
                        },
                    ], // таймлайн
                    comment: "Текст до резюме" // Коментар
                },
                {
                    typeCandidate: 'outsourcing', // тип
                    img: '', // аватар
                    status: 'intern', // Статус
                    companyTitle: 'Finance Dream', // назва компанії
                    firstName: 'Борис', // ім'я кандидата
                    lastName: 'Борисович', // Прізвище кандидата
                    numPhone: '380630000055', // Номер телефону кандидата
                    website: 'https://skyservice.pro', // веб-сайт
                    email: 'ms@gmail.pro', // Пошта кандидата
                    bday: '05.03.1976', // Дата народження
                    city: 'Київ', // Місто
                    district: 'Солома', // Район
                    street: '-', // Вулиця
                    position: 'Бухгалтер', // Посада
                    work_experience: 'Від 1 до 3 років', // Досвід роботи
                    type_of_employment: 'Повна зайнятість', // Тип зайнятості (фріланс, фулл тайм, часткова і тд)
                    work_schedule: '10:00-15:00', // Графік роботи
                    salary: '10000', // Заробітна плата
                    skills: [
                        { label: "Касова дисципліна", value: 'Касова дисципліна' },
                        { label: "Фіскалізація", value: 'Фіскалізація' },
                    ], // Навички
                    social_networks: {
                        instagram: 'https://www.instagram.com/_lol_srly_/',
                        facebook: '',
                        telegram: 'https://t.me/B1sTOnFire',
                        github: 'https://git.skyservice.pro/dashboard/projects'
                    }, // соціальні мережі
                    timeLine: [
                        {
                            nameWorker: 'Max',
                            date: '10.09.2024',
                            time: '14:33',
                            comment: 'Коментар',
                            status: 'new_request'
                        },
                        {
                            nameWorker: 'Юрій',
                            date: '15.09.2024',
                            time: '12:01',
                            comment: 'Коментар',
                            status: 'will_interview'
                        },
                    ], // таймлайн
                    comment: "Текст до резюме" // Коментар
                }
            ]
        }
    },
    methods: {
        getInitials(string) {
            // Отримання ініціалів з імені користувача

            var names = string.split(' '),
            initials = names[0].substring(0, 1).toUpperCase();
            
            if (names.length > 1) {
                initials += names[names.length - 1].substring(0, 1).toUpperCase();
            }
            return initials;
        },
        open(e){
            // Відкриття картки кандидата
            
            this.showCard.data = e
            this.showCard.show = true
        }
    }
}
</script>